const logoutForm = document.getElementById(
  'logout-form',
) as HTMLFormElement | null

if (logoutForm) {
  document.querySelectorAll('button.logout').forEach((logoutButton) => {
    logoutButton.addEventListener('click', () => {
      logoutForm.submit()
    })
  })
}
